import React from "react";

import { VERIFICATION_STATUS, VerificationStatus } from "models";

import { Form, Icon, Option, Select, Typography } from "components";

interface VerificationStatusDropdownProps {
  status: VerificationStatus;
  cropId: string;
  onStatusChange: (cropId: string, newStatus: VerificationStatus) => void;
  disabled?: boolean;
}

export const VerificationStatusDropdown = ({ status, cropId, onStatusChange, disabled = false }: VerificationStatusDropdownProps) => {
  const handleStatusChange = (newStatus: VerificationStatus) => {
    if (newStatus === status) return;
    onStatusChange(cropId, newStatus);
  };

  return (
    <Form name={`verification-form-${cropId}`}>
      <Select
        name={`verification-status-${cropId}`}
        disabled={disabled}
        initialValue={status}
        onChange={handleStatusChange}
        className="verification-select"
        onClick={(e) => e.stopPropagation()}
      >
        <Option value={VERIFICATION_STATUS.autoApproved}>
          <Typography variant="paragraph-m" className="approved">
            <Icon iconName="tabler/circle-check" size="s" className="icon inline margin-right-25" />
            auto-approved
          </Typography>
        </Option>
        <Option value={VERIFICATION_STATUS.approved}>
          <Typography variant="paragraph-m" className="approved">
            <Icon iconName="tabler/circle-check" size="s" className="icon inline margin-right-25" />
            approved
          </Typography>
        </Option>
        <Option value={VERIFICATION_STATUS.pending}>
          <Typography variant="paragraph-m">
            <Icon iconName="tabler/help" size="s" className="icon inline margin-right-25" />
            pending
          </Typography>
        </Option>
        <Option value={VERIFICATION_STATUS.rejected}>
          <Typography variant="paragraph-m" className="rejected">
            <Icon iconName="tabler/circle-x" size="s" className="icon inline margin-right-25" />
            rejected
          </Typography>
        </Option>
        <Option value={null}>
          <Typography variant="paragraph-m">
            <Icon iconName="tabler/circle" size="s" className="icon inline margin-right-25" />
            not verified
          </Typography>
        </Option>
      </Select>
    </Form>
  );
};
